import { Row, Dispatch } from "features/static-load/components/dispatchBoard";

interface GroupedOrigin {
  label: string;
  originCode: string;
  dispatches: Dispatch[];
}

const stripAirportCodeSuffix = (code: string) => code.replace(/\d+$/, "");

const formatDestinationFromTurnNumber = (turnNumber: string) => {
  const [, ...destinationParts] = turnNumber.split("-");
  if (destinationParts.length === 0) return "";

  const segments = destinationParts.map(stripAirportCodeSuffix).filter(Boolean);
  if (segments.length <= 1) {
    return segments[0] ?? "";
  }
  return segments.join(" → ");
};

export const transformLanesToRows = (
  lanesByDay: Record<string, any[]> | undefined,
  dayOfWeek: number
): Row[] => {
  if (!lanesByDay) return [];

  const lanes = lanesByDay[String(dayOfWeek)] ?? [];

  const groupedByOrigin = lanes.reduce<Record<string, GroupedOrigin>>((acc, lane) => {
    const [originCode, ...destinationParts] = lane.turnNumber.split("-");
    const destinationCode = destinationParts.join("-");
    const originLabel = lane.originName || originCode;
    const destinationCodeLabel = destinationCode || originCode;
    const airportLabel =
      formatDestinationFromTurnNumber(lane.turnNumber) ||
      stripAirportCodeSuffix(destinationCodeLabel) ||
      originCode;
    const destinationName = lane.destinationName || destinationCodeLabel;
    const groupKey = originCode || originLabel;

    const formattedTime = lane.earlyDepartureTime.slice(0, 5);

    const dispatch: Dispatch = {
      id: String(lane.id),
      airport: airportLabel,
      destinationName:destinationName,
      origin: originLabel,
      time: formattedTime,
      carrier: lane.carrierName || (lane.carrierNumber !== "0" ? lane.carrierNumber : undefined),
      color: lane.carrierNumber === "1325" ? "blue" : "purple",
      drops: lane.dropCount ?? 0,
      carrierRate: lane.carrierRate ?? "",
    };

    if (!acc[groupKey]) {
      acc[groupKey] = { label: originLabel, originCode: groupKey, dispatches: [] };
    }
    acc[groupKey].dispatches.push(dispatch);

    return acc;
  }, {});

  return Object.values(groupedByOrigin).map((group) => ({
    label: group.label,
    originCode: group.originCode,
    dispatches: group.dispatches,
  }));
};
